<template>
  <div class="bg-primary-orange">
    <div class="flex justify-between items-center text-gray-800 z-10 px-6 h-24">
      <h1 class="text-3xl font-heading">{{ title }}</h1>
    </div>
    <div
      class="flex-1 overflow-y-scroll bg-gray-100 py-6 px-3 rounded-t-xl flex justify-center items-center"
    >
      <div class="text-center">
        <div v-if="mode == 'resetPassword'">
          <form @submit.prevent="resetPassword" class="bg-white rounded-lg p-4 -my-1">
            <p class="mb-2">Enter your new password</p>
            <input
              required
              class="w-full p-2 border border-gray-400 rounded-lg my-1"
              type="password"
              placeholder="*****"
              v-model="newPassword"
            />
            <button
              class="w-full bg-primary-orange rounded-lg py-2 mt-4"
              type="submit"
            >Reset Password</button>
          </form>
          <!-- <button
            @click="state = 'signup'"
            class="text-sm bg-orange-200 py-2 px-4 rounded-lg mt-10"
          >Don't have an account? Sign Up.</button>
          <button class="text-sm bg-red-200 py-2 px-4 rounded-lg mt-3">Forgot password?</button>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notification from "@/components/Notification.vue";

export default {
  name: "actions",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Notification
  },
  data() {
    return {
      title: "",
      mode: "",
      oobCode: "",
      newPassword: ""
    };
  },
  mounted() {
    this.$store.dispatch("setLoading", true);
    this.mode = this.$router.currentRoute.query.mode;
    this.oobCode = this.$router.currentRoute.query.oobCode;

    if (this.mode || this.oobCode) {
      switch (this.mode) {
        case "resetPassword":
          this.title = "Reset Password";
          break;
        case "recoverEmail":
          this.title = "Recover Email";
          break;
        case "verifyEmail":
          this.title = "Verify Email";
          this.verifyEmail();
          break;
      }
    } else {
      this.$store.dispatch("setLoading", false);
      this.$router.replace("/");
    }
  },
  methods: {
    resetPassword: async function() {
      try {
        this.$store.dispatch("setLoading", true);
        await this.AuthService.confirmPasswordReset(
          this.oobCode,
          this.newPassword
        );
        this.$store.dispatch("setLoading", false);
        this.$breadstick.notify(
          ({ h, onClose }) => {
            return h(
              Notification,
              {
                props: {
                  close: onClose
                }
              },
              "Email successfully confirmed."
            );
          },
          {
            position: "bottom"
          }
        );
        this.$router.replace("/login");
      } catch (error) {
        console.error(error);
        this.$breadstick.notify(
          ({ h, onClose }) => {
            return h(
              Notification,
              {
                props: {
                  type: "danger",
                  close: onClose
                }
              },
              error.message
            );
          },
          {
            position: "bottom"
          }
        );
      }
    },
    verifyEmail: async function() {
      try {
        this.$store.dispatch("setLoading", true);
        await this.AuthService.verifyEmail(this.oobCode);
        this.$store.dispatch("setLoading", false);
        this.$router.replace("/");
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>